import React from "react"
import SbEditable from "storyblok-react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import ButtonGroup from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/ButtonGroup"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

// import Swiper core and required modules
import { Autoplay, Navigation, Pagination, A11y } from "swiper"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/scss"

import { useTranslation } from "react-i18next"

const HeroRotationBlock = ({ block }) => {
  const { i18n } = useTranslation()

  return (
    <SbEditable content={block}>
      <section className="relative hero-rotation">
        {i18n.language === "de" && (
          <div className="absolute top-0 left-0 right-0 z-10">
            <div className="flex max-w-screen-xl px-4 pt-2 mx-auto">
              <Link
                className="ml-auto text-sm btn btn-primary rounded-b-xl sm:rounded-xl"
                link="https://shop.bme.de/!/veranstaltungen"
              >
                Veranstaltungssuche
              </Link>
            </div>
          </div>
        )}
        <Swiper
          modules={[Autoplay, Navigation, Pagination, A11y]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          spaceBetween={0}
          slidesPerView={1}
          pagination={{
            el: ".swiper-pagination-" + block._uid,
            bulletClass:
              "inline-block h-4 w-4 bg-gray-300 rounded-full hover:bg-primary-hover mx-1",
            bulletActiveClass: "bg-primary-500",
            clickable: true,
          }}
        >
          {block.hero_slides?.length > 0 &&
            block.hero_slides.map((item, index) => (
              <SwiperSlide key={index}>
                <div
                  key={index}
                  className="relative block mx-auto h-screen-90 md:h-screen-70 xl:h-screen-37vw"
                >
                  <div className="h-full pb-16">
                    <div className="relative h-full">
                      <Image
                        image={item.image}
                        className="object-cover w-full h-full mb-8"
                      />

                      <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                    </div>
                  </div>
                  <div className="absolute inset-0 ">
                    <div className="h-full max-w-screen-lg pt-16 pl-4 pr-4 mx-auto sm:pt-14">
                      <div className="flex flex-col h-full">
                        <div
                          className={`flex flex-col ${
                            item?.content_alignment?.length > 0
                              ? item?.content_alignment
                              : "justify-center"
                          } flex-grow text-white px-grid -mx-grid`}
                        >
                          <div className="w-full mx-auto text-center">
                            {item.kicker?.length > 0 && (
                              <span className="text-base text-white kicker kicker-h1">
                                {item.kicker}
                              </span>
                            )}
                            {item.headline?.length > 0 &&
                              (index === 0 ? (
                                <h1
                                  className="mt-2 text-white md:mt-4 headline headline-h1"
                                  dangerouslySetInnerHTML={{
                                    __html: item.headline.replace(
                                      /#/i,
                                      "<br />"
                                    ),
                                  }}
                                />
                              ) : (
                                <h2
                                  className="mt-2 text-white md:mt-4 headline headline-h1"
                                  dangerouslySetInnerHTML={{
                                    __html: item.headline.replace(
                                      /#/i,
                                      "<br />"
                                    ),
                                  }}
                                />
                              ))}
                            {item.subheadline?.length > 0 && (
                              <div className="mt-2 md:mt-4">
                                <span className="inline subheadline subheadline-h1">
                                  {item.subheadline}
                                </span>
                              </div>
                            )}
                            <ButtonGroup
                              className="mt-4 md:mt-8"
                              buttons={item.buttons}
                            />
                          </div>
                        </div>
                        <div className="relative block pt-6 pb-12 overflow-hidden bg-white border-b border-l border-r border-gray-200 shadow-md x-mx-4 sm:mx-0 rounded-t-xl px-grid lg:px-8 lg:pt-8">
                          <span className="absolute top-0 left-0 z-50 block w-full h-3 transition-colors duration-300 bg-primary"></span>

                          <div className="leading-7 text-black">
                            {item.text?.length > 0 && <span>{item.text}</span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
        <div
          className={`swiper-pagination-${block._uid} absolute inset-x-0 z-30 bottom-0 text-center`}
        ></div>
      </section>
    </SbEditable>
  )
}

export default HeroRotationBlock
